module.exports = __webpack_public_path__ + "static/img/teach-img02-01.296718c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resolution/teach-img02-01.png
// module id = bR/o
// module chunks = 7